import Column from '@components/column'
import CardHeading from '@commons/headings/card'
import Circle from '@components/circle'
import Typography from '@components/typography'
import AppointmentSchedule from '@commons/cards/appointmentSchedule'
import AppointmentScheduleCardLoader from '@commons/cards/appointmentSchedule/loader'
import ScrollView from '@commons/scroll'
import { styleCardItem } from './style'
import { Fragment, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Appointment } from '@apis'
import Empty from '@commons/empty'
import Alert from '@commons/popups/alert'
import useAppointmentActions from '@hooks/useAppointmentActions'
const TodayAppointments = () => {
  const {
    items: appointments,
    loading,
    totalItems,
  } = useSelector((state: any) => state.todayConsultAppointments)
  const {
    alertInfo,
    visible,
    loading: alertLoading,
    handleClickBtn,
    handleClickYes,
    handleClose,
  } = useAppointmentActions({
    selector: 'todayConsultAppointments',
  })
  const fetchData = async () => {
    await Appointment.list({
      params: {
        page: 1,
        limit: 12,
        isToday: true,
        type: 'Consult',
        isSchedule: true,
      },
      state: 'todayConsultAppointments',
      action: 'set',
    }).catch(() => {})
  }
  useEffect(() => {
    if (!appointments?.length) {
      fetchData()
    }
  }, [])
  return (
    <>
      <CardHeading
        title={`Todays Appointments`}
        titleRightComponent={
          <Circle bg="secondary" size={20}>
            <Typography content={totalItems} size={12} tc="white" />
          </Circle>
        }
        hasView
        path="/doctor/appointments/requests"
      />

      <Column
        bg="primary300"
        styleColumn="padding:20px;border-radius:8px;oveflow:hidden"
      >
        <ScrollView onClick={handleClickBtn}>
          {!!loading ? (
            <>
              {Array(6)
                .fill(0)
                ?.map((_: any, index: any) => {
                  return (
                    <Fragment key={index}>
                      <AppointmentScheduleCardLoader
                        styleCard={styleCardItem}
                      />
                    </Fragment>
                  )
                })}
            </>
          ) : (
            <>
              {!!appointments?.length ? (
                <>
                  {appointments?.map((appointment: any) => {
                    return (
                      <Fragment key={appointment?.id}>
                        <AppointmentSchedule
                          hasView
                          appointment={appointment}
                          styleCard={styleCardItem}
                        />
                      </Fragment>
                    )
                  })}
                </>
              ) : (
                <Empty />
              )}
            </>
          )}
        </ScrollView>
      </Column>
      {!!visible && alertInfo?.type == 'confirm' && (
        <Alert
          title={'Confirmed Request'}
          visible={visible}
          description="Are you sure you want to confirmed request ?"
          onClickOk={handleClickYes}
          onClickClose={handleClose}
          loading={alertLoading}
        />
      )}
    </>
  )
}

export default TodayAppointments
